import React from 'react';
import { BookCallButton } from './ui/BookCallButton';
export const StatsSection = () => {
  const scrollToCalendly = () => {
    const element = document.getElementById('calendly');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full pt-0 pb-8" data-id="element-77">
      <div className="max-w-6xl mx-auto px-4" data-id="element-78">
        <div className="flex justify-center" data-id="element-79">
          <BookCallButton onClick={scrollToCalendly} data-id="element-80" />
        </div>
      </div>
    </div>;
};